import React from 'react';
import { getRoute } from '@utils/routes';
import { useRouter } from 'next/router';
import {
  DivContainer,
  TextContainer,
  HelloTypography,
  SubtitleTypography,
  DrawerMenuDivider,
  LoginButton,
} from './helloLoggedOut.styles';
import { useEventTracking } from '@hooks/useEventTracking';
import { InteractionEventTypes } from '@validators/Events/Interactions';

export function HelloLoggedOut() {
  const router = useRouter();
  const { track } = useEventTracking();

  const handleSignIn = () => {
    void track(InteractionEventTypes.ClickLogin, {
      location: 'home',
    });
    void router.push(getRoute('signin'));
  };

  return (
    <DivContainer>
      <TextContainer>
        <HelloTypography>¡Hola!</HelloTypography>
        <SubtitleTypography>
          Ingresa a tu cuenta para ver tus pedidos, boletas, últimas compras,
          etc
        </SubtitleTypography>
      </TextContainer>
      <DrawerMenuDivider />

      <LoginButton onClick={handleSignIn}>Iniciar sesión</LoginButton>
    </DivContainer>
  );
}
